export const preventOrphans = (text: string): string => {
    if (!text) return '';
  
    const orphans = ['i', 'w', 'z', 'a', 'o', 'u'];
    const words = text.split(' ');
    const result: string[] = [];
  
    for (let i = 0; i < words.length; i++) {
      const word = words[i];
  
      if (orphans.includes(word.toLowerCase()) && i < words.length - 1) {
        result.push(word + '\u00A0');
      } else {
        result.push(word);
        if (i < words.length - 1) {
          result.push(' ');
        }
      }
    }
  
    return result.join('');
  };